var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveCb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83081 2.18286V15.7817C9.83081 16.6428 8.78996 17.0739 8.18111 16.465L5.68192 13.9656C5.30502 13.5887 4.6923 13.5887 4.31539 13.9656L1.8162 16.465C1.20735 17.0739 0.166504 16.6428 0.166504 15.7817V2.18286C0.166504 1.11496 1.03146 0.25 2.09936 0.25H7.89795C8.96585 0.25 9.83081 1.11496 9.83081 2.18286Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveCb);
export default __webpack_public_path__ + "static/media/SaveCB.a055b398460e7ad5d2473f49150042ab.svg";
export { ForwardRef as ReactComponent };